import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import DashboardLayout from '../layouts/DashboardLayout';
import HowItWorksContent from '../components/HowItWorksContent';
import howItWorks from '../data/howItWorksContent.json';

// /nasil-calisir tek URL, auth-aware:
//  - Girişli kullanıcı → DashboardLayout (sidebar/topbar) içinde → sistem dışına ATILMAZ.
//  - Girişsiz ziyaretçi / botlar → landing Header+Footer + SEO meta (SSR ile birebir).
export default function HowItWorksPage({ isDarkMode, toggleDarkMode }) {
  const meta = howItWorks?.meta || {};
  // Senkron okuma → flash yok. Stale token olsa DashboardLayout 401'de login'e yönlendirir.
  const [isLoggedIn] = useState(() => {
    try {
      return !!localStorage.getItem('authToken');
    } catch (e) {
      return false;
    }
  });

  // [SEO] Sayfa-özel title/description/canonical (SSR ile birebir; her iki varyantta da doğru, URL aynı).
  useEffect(() => {
    const origin = window.location.origin;
    const title = meta.pageTitle || 'BBTV Nasıl Çalışır? | Bana Bir Tarif Ver';
    const desc = meta.pageDescription || '';
    document.title = title;
    const setMeta = (selector, attr, key, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', value);
    };
    setMeta('meta[name="description"]', 'name', 'description', desc);
    setMeta('meta[property="og:title"]', 'property', 'og:title', title);
    setMeta('meta[property="og:description"]', 'property', 'og:description', desc);
    setMeta('meta[property="og:url"]', 'property', 'og:url', `${origin}/nasil-calisir`);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${origin}/nasil-calisir`);
  }, [meta.pageTitle, meta.pageDescription]);

  // App içi: kullanıcıyı kabuğun içinde tut (dışarı atma).
  if (isLoggedIn) {
    return (
      <DashboardLayout isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode}>
        <HowItWorksContent variant="app" />
      </DashboardLayout>
    );
  }

  // Public / bot: landing chrome.
  return (
    <div className="min-h-screen bg-background text-on-surface dark:bg-[#0a0d10] dark:text-white">
      <Header isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <main className="mx-auto w-full max-w-4xl px-6 pb-24 pt-32">
        <HowItWorksContent variant="public" />
      </main>
      <Footer />
    </div>
  );
}
